import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import _ from 'lodash'
import { selectNewRoles, selectOriginRoles } from 'state/teams'

/**
 * Hook to check if roles permissions has any change
 *
 * @returns true if roles permissions has any change
 */
export const useIsRoleManagementValuesChanged = (): boolean => {
    const newRoles = useSelector(selectNewRoles)
    const originRoles = useSelector(selectOriginRoles)

    const isNotEdited = useMemo(() => {
        if (!newRoles || !originRoles) return true
        return _.isEqual(newRoles, originRoles)
    }, [newRoles, originRoles])

    return !isNotEdited
}
